import { rtkqApi } from "../api/rtkqApi";
import type { SurveyRedirectUrl } from "../cancelSubscriptionSurvey/survey.types";

export const subscriptionProductApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    cancelSubscriptionProduct: build.mutation<
      SurveyRedirectUrl | null,
      { id: number; new_auto_renew_status: number }
    >({
      query: ({ id, new_auto_renew_status }) => ({
        url: `/foundation/api/users/me/subscriptions/${id}/auto-renew-status`,
        method: "PUT",
        body: {
          auto_renew_status: new_auto_renew_status,
        },
      }),
    }),
  }),
});
